import { FC } from "react"
import Button, { ButtonIconPosition } from "@/components/shared/Button"
import { TestId } from "@/constants/globals"
import { UserFormData } from "@/pages/Settings/Users/types"

interface UserPreviewProps {
   user: UserFormData
   onDismiss: () => void
}

const UserPreview: FC<UserPreviewProps> = ({ user, onDismiss }) => {
   const { firstName, lastName, email, phoneNumber, role } = user

   return (
      <div className="user-modal__preview">
         <h1 className="user-modal__preview-title">New user</h1>
         <div className="user-modal__preview-row">
            <div>
               <div className="user-modal__preview-label">Name</div>
               <div
                  className="user-modal__preview-value"
                  data-testid={TestId.USER_FORM_SUCCESS_NAME_TEXT}
               >
                  {firstName}
               </div>
            </div>
            <div>
               <div className="user-modal__preview-label">Surname</div>
               <div
                  className="user-modal__preview-value"
                  data-testid={TestId.USER_FORM_SUCCESS_LAST_NAME_TEXT}
               >
                  {lastName}
               </div>
            </div>
         </div>
         <div className="user-modal__preview-field">
            <div className="user-modal__preview-label">Email</div>
            <div
               className="user-modal__preview-value"
               data-testid={TestId.USER_FORM_SUCCESS_EMAIL_TEXT}
            >
               {email}
            </div>
         </div>
         <div className="user-modal__preview-field">
            <div className="user-modal__preview-label">Phone</div>
            <div
               className="user-modal__preview-value"
               data-testid={TestId.USER_FORM_SUCCESS_PHONE_NUMBER_TEXT}
            >
               {phoneNumber}
            </div>
         </div>
         <div className="user-modal__preview-field">
            <div className="user-modal__preview-label">Role</div>
            <div
               className="user-modal__preview-value"
               data-testid={TestId.USER_FORM_SUCCESS_ROLE_TEXT}
            >
               {role}
            </div>
         </div>
         <Button
            iconName="checkmark"
            iconPosition={ButtonIconPosition.LEFT}
            onClick={onDismiss}
            data-testid={TestId.USER_FORM_SUCCESS_BUTTON}
         >
            Ok
         </Button>
      </div>
   )
}

export default UserPreview
